
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Puzzle from "../../modules/puzzle/Puzzle";
import { puzzleApi } from "../../services/api";
import { getRedis } from "../../lib/serverRedis";
async function getServerSideProps({ params, res }) {
    const { id } = params;
    const redis = await getRedis();
    let puzzles = null;
    let nextPuzzleId = 6497;
    const puzzleCacheKey = `puzzle:${id}`;
    const cached = await redis.get(puzzleCacheKey);
    if (cached) {
        puzzles = JSON.parse(cached);
    }
    else {
        try {
            const response = await puzzleApi.get("/puzzles/" + id);
            puzzles = response.data.puzzles;
            await redis.set(puzzleCacheKey, JSON.stringify(puzzles), "EX", 3600);
        }
        catch (e) {
            console.error("Error in puzzles", id);
        }
    }
    nextPuzzleId = await redis.srandmember("puzzle:ids:level0");
    if (!puzzles) {
        return { notFound: true };
    }
    // 👇 CRITICAL: HTTP caching (memory / CDN, NOT disk)
    res.setHeader("Cache-Control", puzzles ? "public, s-maxage=300, stale-while-revalidate=600" : "no-store");
    return {
        props: {
            puzzles,
            nextPuzzleId,
            index: false,
        },
    };
}
export default Puzzle;

    async function __Next_Translate__getServerSideProps__19e3c8cc48a__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/puzzle/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__19e3c8cc48a__ as getServerSideProps }
  